module.exports = __webpack_public_path__ + "media/assets/icons/quill/font-formatting-ebc9e642acce01ecb5abf8133afae07b.svg";